import Vue from 'vue'
import Policy from './Policy.vue'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'
import VueScroller from 'vue-scroller'

// import $ from 'jquery'
import { Image as VanImage, Button, List, Swipe, SwipeItem, Lazyload, Tab, Tabs, Field,Toast } from 'vant'

import '../../assets/css/reset.css'
import '../../assets/css/common.css'
import '../../components/icon/index'

// import Dialog from '../../components/dialog'
// import Loading from '../../components/loading'
// import toast from '../../components/toast'

import '../../JS/plugin'
import '../../JS/FastClick'
import filters from '../../JS/filter'
//import utils from './JS/utils'

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

Vue.use(VueWechatTitle)
Vue.use(VueScroller)
//Vue.use(utils)
// 按需引用
Vue.use(VanImage)
Vue.use(Button)
Vue.use(List)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Field)
Vue.use(Toast)

// Vue.prototype.$dialog = Dialog
// Vue.prototype.$loading = Loading
Vue.prototype.$toast = Toast
// Vue.prototype.$http = { get, post }

// 注入全局过滤器
Object.keys(filters).forEach(item => {
  Vue.filter(item, filters[item])
})


Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title
  const userInfo = sessionStorage.getItem('userInfo') || null
  if (!userInfo && to.meta.auth) {
    next('/login')
  } else {
    next()
  }
})

export default new Vue({
  el: '#policy',
  router,
  render: h => h(Policy)
})
